<template>
  <v-row dense>
    <v-col>
      <v-btn
        @click="$emit('click')"
        :loading="processing"
        color="primary"
        size="large"
        variant="flat"
      >
        <v-icon
          :start="!!text"
          icon="add"
        />
        <span v-if="!!text">
          {{ $bct(text) }}
        </span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  processing: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: null,
  },
});

defineEmits(['click']);
</script>
